import { getMessages } from '../../../../../../../store/constants';

export const TITLE_SAVE_AS_TEMPLATE = getMessages().getText('card_form_action_save_as_template');
export const SNACKBAR_TEMPLATE_CREATED = getMessages().getText('snackbar.template.created');
export const SNACKBAR_ID_TEMPLATE_CREATED = 'SNACKBAR_ID_TEMPLATE_CREATED';
